export default function SocialCodepen() {
  return (
    <div
      className="ion-icon-social-codepen"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M241.239,303.936c-15.322-10.357-30.742-20.569-46.062-30.93c-2.03-1.373-3.43-1.472-5.502-0.029l-38.871,26.154
		C181.966,319.905,244,361.317,244,361.317v-53.786C243.988,306.307,242.447,304.751,241.239,303.936z"/>
	<path d="M195.092,240.666c15.454-10.16,30.851-20.409,46.109-30.86c1.486-1.018,2.775-3.509,2.799-5.334v-51.706
		c0,0-62.033,41.124-93.262,61.942c13.7,9.159,26.671,17.913,39.787,26.443C191.545,241.813,193.921,241.435,195.092,240.666z"/>
	<path d="M269.838,209.354c15.811,10.703,31.683,21.314,47.627,31.815c0.916,0.604,2.92,0.602,3.839,0l39.751-26.467L268,152.484
		v53.35C268.01,207.035,268.805,208.655,269.838,209.354z"/>
	<path d="M258.109,230.369c-1.21-0.802-3.611-0.528-4.743,0.168c-4.817,2.962-9.463,6.203-14.164,9.355
		c-8.248,5.53-25.356,17.023-25.356,17.023l38.842,25.865c1.748,1.157,4.436,1.22,6.26,0.111l39.014-25.993
		C297.963,256.898,263.883,234.197,258.109,230.369z"/>
	<polygon points="141,237.116 141,276.725 170.622,256.887 	"/>
	<path d="M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M395,297.006
		c0,5.785-2.652,9.868-7.511,13.094c-41.142,27.314-82.251,54.714-123.286,82.188c-5.854,3.918-11.174,3.754-16.984-0.137
		c-40.783-27.314-81.719-54.546-122.625-81.676c-5.11-3.389-7.594-7.557-7.594-13.73v-79.729c0-6.141,2.521-10.332,7.624-13.716
		c40.906-27.13,81.939-54.363,122.724-81.676c5.818-3.896,11.094-4.007,16.938-0.095c41.036,27.474,82.126,54.869,123.261,82.195
		c4.678,3.106,7.453,6.943,7.453,12.66V297.006z"/>
	<path d="M316.247,273.234c-15.054,10.222-30.188,20.326-45.386,30.332c-2.412,1.588-2.888,3.318-2.861,6.189v51.346l93.039-62.004
		l-38.527-25.882C320.167,271.611,318.582,271.648,316.247,273.234z"/>
	<polygon points="370,276.676 370,237.06 340.41,256.933 	"/>
</g>
</svg>
`,
      }}
    />
  )
}
